(function () {
  function initSection(section) {
    if (section.dataset.videoGalleryInit === 'true') return;
    section.dataset.videoGalleryInit = 'true';

    var track = section.querySelector('.video-gallery-track');
    var prevBtn = section.querySelector('.video-gallery-arrow--prev');
    var nextBtn = section.querySelector('.video-gallery-arrow--next');
    var videos = Array.prototype.slice.call(section.querySelectorAll('.video-gallery-video'));

    function scrollAmount() {
      var item = track.querySelector('.video-gallery-item');
      var gap = 20;
      return item ? (item.offsetWidth + gap) * 2 : 300;
    }

    function updateArrows() {
      if (!track || !prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
      prevBtn.classList.toggle('is-disabled', prevBtn.disabled);
      nextBtn.classList.toggle('is-disabled', nextBtn.disabled);
    }

    if (track && prevBtn && nextBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        window.setTimeout(updateArrows, 400);
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        window.setTimeout(updateArrows, 400);
      });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    if ('IntersectionObserver' in window && videos.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              if (!video.src && video.dataset.src) {
                video.src = video.dataset.src;
              }
              var playPromise = video.play();
              if (playPromise && playPromise.catch) {
                playPromise.catch(function () {});
              }
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.35 }
      );
      videos.forEach(function (video) {
        observer.observe(video);
      });
    } else {
      videos.forEach(function (video) {
        if (video.dataset.src) video.src = video.dataset.src;
        video.play && video.play().catch(function () {});
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.video-gallery-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.video-gallery-section');
    if (section) initSection(section);
  });
})();
